import { use } from 'react';
import Routes from 'shared/enums/routes';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';
import RoutePermissions from 'shared/features/auth/authorization/constants/route-permissions';
import Permission from 'shared/features/auth/authorization/enums/permission';

type PermissionAuthorization = {
  hasPermission: (permission: Permission) => boolean;
  hasPermissions: (permissions: Permission[]) => boolean;
  hasRoutePermission: (route: Routes) => boolean;
};

const usePermissionAuthorization = (): PermissionAuthorization => {
  const { permissions: userPermissions } = use(AuthProviderContext);

  const hasPermission = (permission: Permission) => userPermissions?.includes(permission) ?? false;

  const hasRoutePermission = (route: Routes): boolean => {
    const routePermissionConfig = RoutePermissions[route];
    if (!routePermissionConfig) return true;

    const { permissions, permissionConfig } = routePermissionConfig;
    if (permissions === undefined) return true;
    if (permissionConfig && permissionConfig === 'every') return permissions.every((acc) => hasPermission(acc));
    return permissions.some((acc) => hasPermission(acc));
  };

  return {
    hasPermission,
    hasPermissions: (permissions) => permissions.every((permission) => userPermissions.includes(permission)),
    hasRoutePermission,
  };
};

export default usePermissionAuthorization;
